export class CountQuantityModel {
    [key:string]: any;
}